import React from 'react'
import { Link } from 'react-static'
import styled from 'styled-components'
import { position } from 'polished'

const Wrapper = styled.div`
	cursor: pointer;
	text-transform: capitalize;
	position: relative;
	width: 100%;

	span {
		font-size: 1.7em;
		${position('absolute','50%',null,null,'50%')};
		transform: translate(-50%,-50%);
		color: #fff;
	}

	svg {

		* {
			fill: none;
			stroke: ${props => props.theme.secondary.bg3};
			stroke-width: 4;
		}

		.solid {
			fill: ${props => props.theme.secondary.bg3};
		}

		.outline {
			stroke: ${props => props.theme.secondary.bg3};
		}
	}

	@media screen and (min-width: 801px) {
		span {
      visibility: hidden;
		}

		svg {

			* {
				stroke: #fff;
			}

			.solid {
				fill: #fff;
			}

			.outline {
				stroke: #fff;
			}
		}

		&:hover {
			span {
				visibility: visible;
			}

			svg {

				* {
					stroke: ${props => props.theme.secondary.bg3};
				}

				.solid {
					fill: ${props => props.theme.secondary.bg3};
				}
			}
		}

	}
`

const icons = [
	<svg key="overview" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 933 933">
		<circle className="outline" cx="464.5" cy="464.5" r="464"/>
		<path d="M154.4 119.3c39.7 33.5 46.1 35.6 70.6 54 20.5 15.4 47.7 50.7 47.7 101.9"/>
		<path d="M284.8 273.7c0-51.2-25.5-89.2-50.8-108.3 -24.4-18.5-30.9-20.5-70.5-53.9"/>
		<path d="M295.5 345v-62.5h-0.2c-1.2-5-7.3-8.8-14.8-8.8s-13.6 3.8-14.8 8.8H265.5V345"/>
		<path d="M295.5 301.2c0-5.9-6.7-10.7-15-10.7s-15 4.8-15 10.7c0 0.1 0 0.2 0 0.3H265.5v10.7c0-5.9 6.7-10.5 15-10.5 8.2 0 14.8 4.8 15 10.8h0v-11h0C295.5 301.4 295.5 301.3 295.5 301.2z"/>
		<path d="M193.2 88.1c6.6 9.7 14.7 18.9 24.5 27.3 44 37.3 49.9 38.8 75.3 58C313.5 188.8 340.6 223 340.6 274.2"/>
		<path d="M352.7 273.1c0-51.2-25.5-88.6-50.7-107.8 -25.4-19.3-31.3-20.7-75.3-58 -9.6-8.1-17.4-16.9-23.8-26.1"/>
		<path d="M363.5 345v-63.5h-0.2c-1.2-5-7.3-8.8-14.8-8.8s-13.6 3.8-14.8 8.8H333.5V345"/>
		<path d="M363.5 301.2c0-5.9-6.7-10.7-15-10.7s-15 4.8-15 10.7c0 0.1 0 0.2 0 0.3H333.5v10.7c0-5.9 6.7-10.5 15-10.5 8.2 0 14.8 4.8 15 10.8h0v-11h0C363.5 301.4 363.5 301.3 363.5 301.2z"/>
		<path d="M244 56.1c8.2 21.1 21 42.7 41.6 60.2 44 37.3 49.9 38.8 75.3 58 20.5 15.4 47.6 48.7 47.6 99.9"/>
		<path d="M420.8 273.1c0-51.2-25.5-87.6-50.8-106.8 -25.4-19.3-31.3-20.7-75.3-58 -20.4-17.3-32.8-37.7-40.7-57.5"/>
		<path d="M431.5 345v-63.5h-0.2c-1.2-5-7.3-8.8-14.8-8.8s-13.6 3.8-14.8 8.8H401.5V345"/>
		<path d="M431.5 302.2c0-5.9-6.7-10.7-15-10.7s-15 4.8-15 10.7c0 0.1 0 0.2 0 0.3H401.5v10.7c0-5.9 6.7-10.5 15-10.5 8.2 0 14.8 4.8 15 10.8h0v-11h0C431.5 302.4 431.5 302.3 431.5 302.2z"/>
		<path d="M394 5.8c4.7 25.3 4.3 66.8 54.6 109.5 44 37.3 49.9 38.8 75.3 58 20.5 15.4 47.6 49.7 47.6 100.9"/>
		<path d="M583.7 273.1c0-51.2-25.5-88.6-50.7-107.8 -25.4-19.3-31.3-20.7-75.3-58 -50.3-42.7-48-77.7-52.7-103"/>
		<path d="M594.5 345v-63.5h-0.2c-1.2-5-7.3-8.8-14.8-8.8s-13.6 3.8-14.8 8.8H564.5V345"/>
		<path d="M594.5 301.2c0-5.9-6.7-10.7-15-10.7s-15 4.8-15 10.7c0 0.1 0 0.2 0 0.3H564.5v10.7c0-5.9 6.7-10.5 15-10.5 8.2 0 14.8 4.8 15 10.8h0v-11h0C594.5 301.4 594.5 301.3 594.5 301.2z"/>
		<path d="M461 0.5c4.7 25.3 5.3 73.1 55.7 115.8 44 37.3 49.9 38.8 75.3 58 20.5 15.4 47.6 48.7 47.6 99.9"/>
		<path d="M651.8 273.1c0-51.2-25.5-87.6-50.8-106.8 -25.4-19.3-31.3-20.7-75.3-58 -50.3-42.7-48.8-82.4-53.4-107.8"/>
		<path d="M662.5 345v-63.5h-0.2c-1.2-5-7.3-8.8-14.8-8.8s-13.6 3.8-14.8 8.8H632.5V345"/>
		<path d="M662.5 302.2c0-5.9-6.7-10.7-15-10.7s-15 4.8-15 10.7c0 0.1 0 0.2 0 0.3H632.5v10.7c0-5.9 6.7-10.5 15-10.5 8.2 0 14.8 4.8 15 10.8h0v-11h0C662.5 302.4 662.5 302.3 662.5 302.2z"/>
		<path d="M211 727.5c-0.5-1.1-11.1-30.7-12.2-33.7 -1.2-3.5-1.3-6.7-1.2-9.5 0.1-2.7 5.5-333.8 5.5-336.2 0-2.3 1.4-3.2 2.9-3.3 -7.9 0-12.4 0-12.6 0 -1.2 0.1-2.3 1.2-2.3 2.5s-7.1 335.5-7.2 339.2c0 4.4 0.9 7 2.3 10.7s10.7 27.2 11.7 29.2c0.9 2 2.1 3.3 4.3 3.3 0.2 0 4.2 0 11.3 0C212.4 729.5 211.5 728.6 211 727.5z"/>
		<path d="M749.2 682c-0.1-4.3-9.8-331.8-9.9-334.8s-1.4-2.5-3.2-2.5c-0.1 0-4.1 0-11.4 0 0.9 0 2.2-0.2 2.3 1.9C727 348.8 735.8 672 736 678.3c0.3 8.4-0.4 12.9-2.5 16.8 -2.3 4.6-14.1 28.2-15 30 -0.9 1.8-1.7 4-4.2 4.3 6 0 9.4 0 9.7 0 4.1 0 5.2-0.4 6.2-2.2s15-30.3 16.8-34S749.3 686.3 749.2 682z"/>
		<path d="M718.7 726.3c0.9-1.8 12.5-26.8 14.8-31.3 2.1-3.9 2.8-8.4 2.5-16.7 -0.2-6.2-9-329.5-9.1-331.6 -0.1-2.1-1.3-1.9-2.3-1.9 -70.7-0.2-445.1 0.2-518.8 0 -1.5 0.1-2.9 1-2.9 3.3 0 2.4-5.4 333.5-5.5 336.3 0 2.8 0 6 1.3 9.5 1.1 3.1 11.8 32.6 12.3 33.8 0.5 1.1 1.4 2 2.5 2 69.4-0.1 436 0 500.8-0.1C716.8 729 717.8 728.1 718.7 726.3z"/>
		<path d="M198 690.1c0 0 2 2.9 5.5 2.9s521.1-1.8 524.5-2 7.5-1.5 7.5-1.5"/>
		<path d="M264.8 523.1c-0.3-0.5-1-0.9-1.5-0.9l-14.3 0c-0.5 0-1.2 0.4-1.5 0.9l-7.1 12.1c-0.3 0.5-0.3 1.2 0 1.7l7.2 12.1c0.3 0.5 1 0.9 1.5 0.9l14.3 0c0.6 0 1.2-0.4 1.5-0.9l7.1-12.1c0.3-0.5 0.3-1.2 0-1.7L264.8 523.1z"/>
		<path d="M261.6 520.3c0 0 0-0.1 0-0.1 0-2.8-2.7-5-5.6-4.9s-5.5 2.3-5.5 5c0 0 0 0.1 0 0.1s2.7 16.3 2.8 16.5c0.2 1.1 1.1 1.9 2.7 1.9 1.5 0 2.3-0.6 2.7-1.9C259.1 535.7 261.6 520.3 261.6 520.3z" className="solid"/>
		<path d="M263.8 600.1c-0.3-0.5-1-0.9-1.5-0.9l-14.3 0c-0.5 0-1.2 0.4-1.5 0.9l-7.1 12.1c-0.3 0.5-0.3 1.2 0 1.7l7.2 12.1c0.3 0.5 1 0.9 1.5 0.9l14.3 0c0.6 0 1.2-0.4 1.5-0.9l7.1-12.1c0.3-0.5 0.3-1.2 0-1.7L263.8 600.1z"/>
		<path d="M260.6 597.3c0 0 0-0.1 0-0.1 0-2.8-2.7-5-5.6-4.9s-5.5 2.3-5.5 5c0 0 0 0.1 0 0.1s2.7 16.3 2.8 16.5c0.2 1.1 1.1 1.9 2.7 1.9 1.5 0 2.3-0.6 2.7-1.9C258.1 612.7 260.6 597.3 260.6 597.3z" className="solid"/>
		<path d="M340.8 598.1c-0.3-0.5-1-0.9-1.5-0.9l-14.3 0c-0.5 0-1.2 0.4-1.5 0.9l-7.1 12.1c-0.3 0.5-0.3 1.2 0 1.7l7.2 12.1c0.3 0.5 1 0.9 1.5 0.9l14.3 0c0.6 0 1.2-0.4 1.5-0.9l7.1-12.1c0.3-0.5 0.3-1.2 0-1.7L340.8 598.1z"/>
		<path d="M337.6 595.3c0 0 0-0.1 0-0.1 0-2.8-2.7-5-5.6-4.9s-5.5 2.3-5.5 5c0 0 0 0.1 0 0.1s2.7 16.3 2.8 16.5c0.2 1.1 1.1 1.9 2.7 1.9 1.5 0 2.3-0.6 2.7-1.9C335.1 610.7 337.6 595.3 337.6 595.3z" className="solid"/>
		<path d="M417.8 599.1c-0.3-0.5-1-0.9-1.5-0.9l-14.3 0c-0.5 0-1.2 0.4-1.5 0.9l-7.1 12.1c-0.3 0.5-0.3 1.2 0 1.7l7.2 12.1c0.3 0.5 1 0.9 1.5 0.9l14.3 0c0.6 0 1.2-0.4 1.5-0.9l7.1-12.1c0.3-0.5 0.3-1.2 0-1.7L417.8 599.1z"/>
		<path d="M414.6 596.3c0 0 0-0.1 0-0.1 0-2.8-2.7-5-5.6-4.9s-5.5 2.3-5.5 5c0 0 0 0.1 0 0.1s2.7 16.3 2.8 16.5c0.2 1.1 1.1 1.9 2.7 1.9 1.5 0 2.3-0.6 2.7-1.9C412.1 611.7 414.6 596.3 414.6 596.3z" className="solid"/>
		<path d="M516.8 597.1c-0.3-0.5-1-0.9-1.5-0.9l-14.3 0c-0.5 0-1.2 0.4-1.5 0.9l-7.1 12.1c-0.3 0.5-0.3 1.2 0 1.7l7.2 12.1c0.3 0.5 1 0.9 1.5 0.9l14.3 0c0.6 0 1.2-0.4 1.5-0.9l7.1-12.1c0.3-0.5 0.3-1.2 0-1.7L516.8 597.1z"/>
		<path d="M513.6 594.3c0 0 0-0.1 0-0.1 0-2.8-2.7-5-5.6-4.9s-5.5 2.3-5.5 5c0 0 0 0.1 0 0.1s2.7 16.3 2.8 16.5c0.2 1.1 1.1 1.9 2.7 1.9 1.5 0 2.3-0.6 2.7-1.9C511.1 609.7 513.6 594.3 513.6 594.3z" className="solid"/>
		<path d="M593.8 598.1c-0.3-0.5-1-0.9-1.5-0.9l-14.3 0c-0.5 0-1.2 0.4-1.5 0.9l-7.1 12.1c-0.3 0.5-0.3 1.2 0 1.7l7.2 12.1c0.3 0.5 1 0.9 1.5 0.9l14.3 0c0.6 0 1.2-0.4 1.5-0.9l7.1-12.1c0.3-0.5 0.3-1.2 0-1.7L593.8 598.1z"/>
		<path d="M590.6 595.3c0 0 0-0.1 0-0.1 0-2.8-2.7-5-5.6-4.9s-5.5 2.3-5.5 5c0 0 0 0.1 0 0.1s2.7 16.3 2.8 16.5c0.2 1.1 1.1 1.9 2.7 1.9 1.5 0 2.3-0.6 2.7-1.9C588.1 610.7 590.6 595.3 590.6 595.3z" className="solid"/>
		<path d="M692.8 597.1c-0.3-0.5-1-0.9-1.5-0.9l-14.3 0c-0.5 0-1.2 0.4-1.5 0.9l-7.1 12.1c-0.3 0.5-0.3 1.2 0 1.7l7.2 12.1c0.3 0.5 1 0.9 1.5 0.9l14.3 0c0.6 0 1.2-0.4 1.5-0.9l7.1-12.1c0.3-0.5 0.3-1.2 0-1.7L692.8 597.1z"/>
		<path d="M689.6 594.3c0 0 0-0.1 0-0.1 0-2.8-2.7-5-5.6-4.9s-5.5 2.3-5.5 5c0 0 0 0.1 0 0.1s2.7 16.3 2.8 16.5c0.2 1.1 1.1 1.9 2.7 1.9 1.5 0 2.3-0.6 2.7-1.9C687.1 609.7 689.6 594.3 689.6 594.3z" className="solid"/>
		<path d="M690.8 521.1c-0.3-0.5-1-0.9-1.5-0.9l-14.3 0c-0.5 0-1.2 0.4-1.5 0.9l-7.1 12.1c-0.3 0.5-0.3 1.2 0 1.7l7.2 12.1c0.3 0.5 1 0.9 1.5 0.9l14.3 0c0.6 0 1.2-0.4 1.5-0.9l7.1-12.1c0.3-0.5 0.3-1.2 0-1.7L690.8 521.1z"/>
		<path d="M687.6 518.3c0 0 0-0.1 0-0.1 0-2.8-2.7-5-5.6-4.9s-5.5 2.3-5.5 5c0 0 0 0.1 0 0.1s2.7 16.3 2.8 16.5c0.2 1.1 1.1 1.9 2.7 1.9 1.5 0 2.3-0.6 2.7-1.9C685.1 533.7 687.6 518.3 687.6 518.3z" className="solid"/>
		<circle cx="543.7" cy="435.3" r="71"/>
		<path d="M491.8 446.8c4.2-3.5 6.5-8.3 6.5-14.4 0-5.6-1.2-9.2-5.6-13.5"/>
		<path d="M515.3 479.7c-0.2-9.1-7.5-16.4-16.6-16.5"/>
		<path d="M531 383c4 3.4 7.7 5.4 13 5.4 5.2 0 9.2-2.2 13-5.3"/>
		<path d="M499 405.7c0.1 0 0.3 0 0.4 0 9.2 0 16.7-7.4 16.8-16.6"/>
		<path d="M594.3 418.3c-4.6 4.5-5.8 8.5-5.8 14.5 0 6.4 2.7 11 6.8 14.5"/>
		<path d="M569.9 388.4c0 0.2 0 0.3 0 0.5 0 9.3 7.5 16.8 16.8 16.8 0.5 0 1 0 1.5-0.1"/>
		<path d="M589.8 461.3c-0.4 0-0.7-0.1-1.1-0.1 -9.3 0-16.8 7.5-16.8 16.8 0 0.6 0 1.1 0.1 1.7"/>
		<path d="M557.9 486c-3.6-3.5-8.1-6.3-13.9-6.3 -5.8 0-10.1 2.3-13.9 6.5"/>
		<path d="M491.8 446.8c-0.3 0.2-0.4 0.3-0.6 0.3s0 1 0.3 2.1l5.1 12.4c0.5 1 1.2 1.9 1.5 1.9 0 0 0 0 0.3 0 0.1 0 0.2-0.1 0.2-0.1"/>
		<path d="M515.4 479.7c0 0.1 0.1 0.2 0.1 0.3 0 0.3 0 0.3 0 0.3 0 0.3 0.7 1 1.6 1.5l10.6 4.6c1 0.4 1.9 0.5 2.1 0.3 0.1-0.2 0.2-0.3 0.4-0.6"/>
		<path d="M499 405.7c-0.4 0-0.6 0-0.8 0s-0.8 0.8-1.4 1.7l-4.2 9.1c-0.4 1-0.6 2-0.4 2.1s0.3 0.2 0.6 0.4"/>
		<path d="M557.9 486c0.2 0.3 0.3 0.5 0.5 0.7 0.1 0.2 1.1 0.1 2.1-0.3l9.9-4.3c1-0.5 1.7-1.1 1.7-1.4 0-0.3-0.1-0.5-0.1-0.9"/>
		<path d="M569.9 388.4c0-0.5 0-0.8 0.1-1 0-0.3-0.8-0.9-1.8-1.4l-8.5-3.4c-1-0.3-2-0.5-2.2-0.2 -0.2 0.2-0.3 0.4-0.6 0.8"/>
		<path d="M531 383c-0.3-0.4-0.4-0.5-0.5-0.7s-1.1-0.1-2.2 0.3l-10.2 4.3c-1 0.5-1.6 1.2-1.6 1.7 0 0 0 0 0 0.4 0 0.1-0.1 0.1-0.1 0.2"/>
		<path d="M589.8 461.3c0.5 0 0.7 0.1 1 0.1s0.9-0.7 1.4-1.7l3.9-9.8c0.3-1 0.4-2 0.2-2.1 -0.2-0.1-0.4-0.2-0.9-0.4"/>
		<path d="M594.3 418.3c0.4-0.3 0.6-0.4 0.9-0.5 0.2-0.1 0.1-1.1-0.3-2.1l-4.1-8.5c-0.5-1-1.2-1.7-1.5-1.7 -0.3 0-0.5 0.1-1.1 0.1"/>
		<circle cx="543.5" cy="434.2" r="36"/>
		<circle className="solid" cx="332.6" cy="437.1" r="44.1"/>
		<circle cx="332.6" cy="437.1" r="57.6"/>
	</svg>,
	<svg key="outboard" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 933 933">
		<circle className="outline" cx="464.5" cy="464.5" r="464"/>
		<path d="M850 603.8c0 2.8-2.2 5-5 5H83c-2.7 0-5-2.2-5-5V326.2c0-2.7 2.3-5 5-5h762c2.8 0 5 2.3 5 5V603.8z"/>
		<path d="M635.8 584.9c0 5.5-4.5 10-10 10H507.2c-5.5 0-10-4.5-10-10V484.1c0-5.5 4.5-10 10-10H625.8c5.5 0 10 4.5 10 10V584.9z"/>
		<path d=""/>
		<path d="M615.4 518.4c-27.6-21.9-63.9-28-96.5 0"/>
		<path d="M557.7 516.9h1.3l2.3 6.9c0.1 0.3 0.2 0.6 0.3 1 0.1-0.4 0.2-0.7 0.3-1l2.2-6.9h1.3l-3.3 9.6h-1.1L557.7 516.9z" className="fill"/>
		<path d="M567.2 522.9v-6h1.2v6c0 2.1 1 2.6 2.3 2.6 1.2 0 2.3-0.5 2.3-2.6v-6h1.2v6c0 2.8-1.4 3.8-3.5 3.8C568.7 526.6 567.2 525.6 567.2 522.9z" className="fill"/>
		<path d="M528.5 525.8c-0.4-1.1-1-2-2.8-2.4s-2.4-0.8-3.3-1.5c-0.9-0.7-3.5-3.5-3.5-3.5v0c0 0 2.5 2.8 3.1 3.8 0.7 1 1.1 1.6 1.3 3.4 0.2 1.8 1.1 2.5 2.1 3 1 0.5 2.7-0.1 4.6 2C528.2 528.5 528.9 526.9 528.5 525.8z" className="fill"/>
		<line x1="530" y1="530.6" x2="545.5" y2="545.8" className="fill"/>
		<line x1="635.8" y1="545.8" x2="497.2" y2="545.8" className="fill"/>
		<circle cx="566.9" cy="581.4" r="7"/>
		<line x1="562.8" y1="579.8" x2="571" y2="582.8"/>
		<path d="M634.8 443.2c0 5.5-4.5 10-10 10H506.2c-5.5 0-10-4.5-10-10V342.4c0-5.5 4.5-10 10-10h118.6c5.5 0 10 4.5 10 10V443.2z"/>
		<path d=""/>
		<path d="M614.4 376.7c-27.6-21.9-63.9-28-96.5 0"/>
		<path d="M556.6 375.1h1.3l2.3 6.9c0.1 0.3 0.2 0.6 0.3 1 0.1-0.4 0.2-0.7 0.3-1l2.2-6.9h1.3l-3.3 9.6h-1.1L556.6 375.1z" className="fill"/>
		<path d="M566.2 381.1v-6h1.2v6c0 2.1 1 2.6 2.3 2.6 1.2 0 2.3-0.5 2.3-2.6v-6h1.2v6c0 2.8-1.4 3.8-3.5 3.8C567.6 384.9 566.2 383.9 566.2 381.1z" className="fill"/>
		<path d="M527.5 384.1c-0.4-1.1-1-2-2.8-2.4s-2.4-0.8-3.3-1.5c-0.9-0.7-3.5-3.5-3.5-3.5v0c0 0 2.5 2.8 3.1 3.8 0.7 1 1.1 1.6 1.3 3.4 0.2 1.8 1.1 2.5 2.1 3 1 0.5 2.7-0.1 4.6 2C527.1 386.7 527.8 385.1 527.5 384.1z" className="fill"/>
		<line x1="529" y1="388.9" x2="544.4" y2="404.1" className="fill"/>
		<line x1="634.8" y1="404.1" x2="496.2" y2="404.1" className="fill"/>
		<circle cx="565.9" cy="439.7" r="7"/>
		<line x1="561.7" y1="438.1" x2="569.9" y2="441.1"/>
		<circle cx="773.7" cy="391.3" r="47.2"/>
		<path d="M739.2 399c2.8-2.3 4.4-5.5 4.4-9.6 0-3.7-0.8-6.1-3.7-9"/>
		<path d="M754.8 420.8c-0.1-6-5-10.9-11-11"/>
		<path d="M765.3 356.5c2.7 2.2 5.1 3.6 8.6 3.6 3.5 0 6.1-1.4 8.6-3.5"/>
		<path d="M744 371.6c0.1 0 0.2 0 0.3 0 6.1 0 11.1-4.9 11.2-11.1"/>
		<path d="M807.3 380c-3 3-3.8 5.7-3.8 9.7 0 4.3 1.8 7.3 4.5 9.7"/>
		<path d="M791.1 360.1c0 0.1 0 0.2 0 0.3 0 6.2 5 11.2 11.2 11.2 0.3 0 0.7 0 1 0"/>
		<path d="M804.3 408.6c-0.2 0-0.5 0-0.7 0 -6.2 0-11.2 5-11.2 11.2 0 0.4 0 0.8 0.1 1.1"/>
		<path d="M783.1 425c-2.4-2.3-5.4-4.2-9.2-4.2 -3.9 0-6.7 1.5-9.2 4.3"/>
		<path d="M739.2 399c-0.2 0.1-0.2 0.1-0.2 0.1 -0.2 0.1-0.1 1.1 0.2 2.1l2.9 6.7c0.5 1 1.1 1.6 1.3 1.6 0 0 0 0 0.2 0 0.1 0 0.1 0.2 0.2 0.2"/>
		<path d="M754.6 420.8c0 0.1-0.1 0.1-0.1 0.2 0 0.2 0 0.2 0 0.2 0 0.2 0.9 0.8 1.9 1.3l5.9 2.5c1 0.4 2 0.6 2.1 0.5 0.1-0.1 0.1-0.2 0.2-0.4"/>
		<path d="M744 371.6c-0.3 0-0.3 0-0.3 0 -0.3 0-1 0.8-1.5 1.7l-2.2 4.8c-0.4 1-0.6 1.9-0.5 2 0.1 0.1 0.2 0.1 0.4 0.3"/>
		<path d="M783.1 425c0.2 0.2 0.2 0.2 0.2 0.2 0.2 0.3 1.1 0.2 2.2-0.2l5.4-2.3c1-0.5 1.8-1.1 1.7-1.2 0-0.2 0-0.3-0.1-0.6"/>
		<path d="M791.1 360.1c0-0.3 0-0.3 0-0.3 0-0.4-0.7-1.1-1.7-1.5l-4.4-1.8c-1-0.3-2-0.5-2.1-0.4s-0.2 0.3-0.4 0.5"/>
		<path d="M765.3 356.5c-0.2-0.2-0.2-0.2-0.2-0.2 -0.2-0.3-1.2-0.2-2.2 0.2l-5.6 2.3c-1 0.5-1.7 1.1-1.7 1.4 0 0 0 0 0 0.3 0 0 0 0.1 0 0.1"/>
		<path d="M804.3 408.6c0.3 0 0.3 0 0.3 0 0.4 0 1.1-0.7 1.5-1.7l2.1-5.3c0.3-1 0.5-2 0.3-2s-0.3-0.1-0.6-0.3"/>
		<path d="M807.3 380c0.3-0.2 0.3-0.2 0.3-0.2 0.3-0.2 0.2-1.2-0.2-2.2l-2.1-4.5c-0.5-1-1.1-1.7-1.3-1.7 -0.2 0-0.4 0.1-0.7 0.1"/>
		<circle cx="773.6" cy="390.6" r="23.9"/>
		<circle cx="773.7" cy="509.3" r="47.2"/>
		<path d="M739.2 517c2.8-2.3 4.4-5.5 4.4-9.6 0-3.7-0.8-6.1-3.7-9"/>
		<path d="M754.8 538.8c-0.1-6-5-10.9-11-11"/>
		<path d="M765.3 474.5c2.7 2.2 5.1 3.6 8.6 3.6 3.5 0 6.1-1.4 8.6-3.5"/>
		<path d="M744 489.6c0.1 0 0.2 0 0.3 0 6.1 0 11.1-4.9 11.2-11.1"/>
		<path d="M807.3 498c-3 3-3.8 5.7-3.8 9.7 0 4.3 1.8 7.3 4.5 9.7"/>
		<path d="M791.1 478.1c0 0.1 0 0.2 0 0.3 0 6.2 5 11.2 11.2 11.2 0.3 0 0.7 0 1-0.1"/>
		<path d="M804.3 526.6c-0.2 0-0.5 0-0.7 0 -6.2 0-11.2 5-11.2 11.2 0 0.4 0 0.8 0.1 1.1"/>
		<path d="M783.1 543c-2.4-2.3-5.4-4.2-9.2-4.2 -3.9 0-6.7 1.5-9.2 4.3"/>
		<path d="M739.2 517c-0.2 0.1-0.2 0.1-0.2 0.1 -0.2 0.1-0.1 1.1 0.2 2.1l2.9 6.7c0.5 1 1.1 1.6 1.3 1.6 0 0 0 0 0.2 0 0.1 0 0.1 0.2 0.2 0.2"/>
		<path d="M754.6 538.8c0 0.1-0.1 0.1-0.1 0.2 0 0.2 0 0.2 0 0.2 0 0.2 0.9 0.8 1.9 1.3l5.9 2.5c1 0.4 2 0.6 2.1 0.5 0.1-0.1 0.1-0.2 0.2-0.4"/>
		<path d="M744 489.6c-0.3 0-0.3 0-0.3 0 -0.3 0-1 0.8-1.5 1.7l-2.2 4.8c-0.4 1-0.6 1.9-0.5 2 0.1 0.1 0.2 0.1 0.4 0.3"/>
		<path d="M783.1 543c0.2 0.2 0.2 0.2 0.2 0.2 0.2 0.3 1.1 0.2 2.2-0.2l5.4-2.3c1-0.5 1.8-1.1 1.7-1.2 0-0.2 0-0.3-0.1-0.6"/>
		<path d="M791.1 478.1c0-0.3 0-0.3 0-0.3 0-0.4-0.7-1.1-1.7-1.5l-4.4-1.8c-1-0.3-2-0.5-2.1-0.4 -0.1 0.1-0.2 0.3-0.4 0.5"/>
		<path d="M765.3 474.5c-0.2-0.2-0.2-0.2-0.2-0.2 -0.2-0.3-1.2-0.2-2.2 0.2l-5.6 2.3c-1 0.5-1.7 1.1-1.7 1.4 0 0 0 0 0 0.3 0 0 0 0.1 0 0.1"/>
		<path d="M804.3 526.6c0.3 0 0.3 0 0.3 0 0.4 0 1.1-0.7 1.5-1.7l2.1-5.3c0.3-1 0.5-2 0.3-2 -0.2-0.1-0.3-0.1-0.6-0.3"/>
		<path d="M807.3 498c0.3-0.2 0.3-0.2 0.3-0.2 0.3-0.2 0.2-1.2-0.2-2.2l-2.1-4.5c-0.5-1-1.1-1.7-1.3-1.7 -0.2 0-0.4 0.1-0.7 0.1"/>
		<circle cx="773.6" cy="508.6" r="23.9"/>
		<path d="M407.5 334.3c-1.3 0.6-3.9 10.3-4.5 11.7s9.5 26.4 10.6 27.7 4.8 5.7 6.4 6.1 9.9-2.9 10.5-3.9 -0.1-9.3 0-8 -9.4-28.3-10.5-28.8S408.8 333.7 407.5 334.3z"/>
		<path d="M403.5 348.3l-1 2.1c-6.3 17.5 2.7 23.5 10 29.4 0 0 6.2 7.9 7.7 8.3s14.6-4.4 15.4-5.5 -0.4-11.2-0.4-11.2c1.5-8 4.7-19.6-12.2-28.6l-1.9-1.4"/>
		<line x1="420" y1="379.9" x2="420.2" y2="388.2"/>
		<line x1="430.5" y1="376" x2="435.6" y2="382.7"/>
		<path d="M407.2 334.7c-0.2 0.2-0.2 0.8 0 1.3l4.3 10.7c0.2 0.5 0.4 1.4 0.5 1.9l0.4 4.9c0.1 0.5 0.5 0.8 1 0.6l4.1-2c0.5-0.2 0.6-0.8 0.2-1.2l-2.9-3.4c-0.4-0.4-0.8-1.2-1.1-1.7l-4.5-10.5c-0.2-0.5-0.7-0.9-1.1-1C407.8 334.3 407.3 334.4 407.2 334.7z"/>
		<path d="M405.5 481.3c-1.3 0.6-3.9 10.3-4.5 11.7s9.5 26.4 10.6 27.7 4.8 5.7 6.4 6.1c1.5 0.5 9.9-2.9 10.5-3.9 0.7-1-0.1-9.3 0-8s-9.4-28.3-10.5-28.8S406.8 480.7 405.5 481.3z"/>
		<path d="M401.5 495.3l-1 2.1c-6.3 17.5 2.7 23.5 10 29.4 0 0 6.2 7.9 7.7 8.3s14.6-4.4 15.4-5.5 -0.4-11.2-0.4-11.2c1.5-8 4.7-19.6-12.2-28.6l-1.9-1.4"/>
		<line x1="418" y1="526.9" x2="418.2" y2="535.2"/>
		<line x1="428.5" y1="523" x2="433.6" y2="529.7"/>
		<path d="M405.2 481.7c-0.2 0.2-0.2 0.8 0 1.3l4.3 10.7c0.2 0.5 0.4 1.4 0.5 1.9l0.4 4.9c0.1 0.5 0.5 0.8 1 0.6l4.1-2c0.5-0.2 0.6-0.8 0.2-1.2l-2.9-3.4c-0.4-0.4-0.8-1.2-1.1-1.7l-4.5-10.5c-0.2-0.5-0.7-0.9-1.1-1C405.8 481.3 405.3 481.4 405.2 481.7z"/>
		<path d="M349.8 485.7c-1.2-0.9-10.9 1.5-12.5 1.7 -1.5 0.2-18.6 21-19.2 22.6s-2.6 7-2.3 8.5c0.3 1.6 7.2 7.3 8.4 7.4 1.2 0.1 8.1-4.6 7-3.8 -1.1 0.7 20.3-21.8 20.2-23.1C351.5 497.7 351 486.6 349.8 485.7z"/>
		<path d="M335.5 488.9l-2.3 0.2c-18.4 2.9-19.3 13.7-21 22.9 0 0-3.9 9.2-3.6 10.8s10.9 10.7 12.3 10.8c1.4 0.1 9.7-5.8 9.7-5.8 7.7-2.5 19.4-5.3 19.2-24.4l0.3-2.3"/>
		<line x1="315.8" y1="518.6" x2="308.6" y2="522.8"/>
		<line x1="324.2" y1="525.9" x2="320.8" y2="533.6"/>
		<path d="M349.3 485.6c-0.3-0.1-0.8 0.3-1.2 0.7l-7.3 8.9c-0.3 0.4-1 1-1.5 1.3l-4.1 2.7c-0.5 0.3-0.5 0.8 0 1.1l3.7 2.6c0.4 0.3 1 0.2 1.2-0.4l1.5-4.2c0.2-0.5 0.6-1.3 1-1.7l7.1-9c0.3-0.4 0.5-1.1 0.4-1.4C349.9 486 349.6 485.7 349.3 485.6z"/>
		<path d="M353.8 339.7c-1.2-0.9-10.9 1.5-12.5 1.7 -1.5 0.2-18.6 21-19.2 22.6s-2.6 7-2.3 8.5c0.3 1.6 7.2 7.3 8.4 7.4 1.2 0.1 8.1-4.6 7-3.8 -1.1 0.7 20.3-21.8 20.2-23.1C355.5 351.7 355 340.6 353.8 339.7z"/>
		<path d="M339.5 342.9l-2.3 0.2c-18.4 2.9-19.3 13.7-21 22.9 0 0-3.9 9.2-3.6 10.8s10.9 10.7 12.3 10.8c1.4 0.1 9.7-5.8 9.7-5.8 7.7-2.5 19.4-5.3 19.2-24.4l0.3-2.3"/>
		<line x1="319.8" y1="372.6" x2="312.6" y2="376.8"/>
		<line x1="328.2" y1="379.9" x2="324.8" y2="387.6"/>
		<path d="M353.3 339.6c-0.3-0.1-0.8 0.3-1.2 0.7l-7.3 8.9c-0.3 0.4-1 1-1.5 1.3l-4.1 2.7c-0.5 0.3-0.5 0.8 0 1.1l3.7 2.6c0.4 0.3 1 0.2 1.2-0.4l1.5-4.2c0.2-0.5 0.6-1.3 1-1.7l7.1-9c0.3-0.4 0.5-1.1 0.4-1.4S353.6 339.7 353.3 339.6z"/>
		<path d="M684 361.5c0 6.3 5.1 11.5 11.5 11.5s11.5-5.1 11.5-11.5 -5.1-11.5-11.5-11.5c-1.2 0-2.5 0.3-2.5 0.3 -0.5 0.1-1 0.2-1 0.2s-0.4-0.2-0.8-0.5l-3.8-2.4c-0.5-0.3-0.8-0.1-0.7 0.5l0.5 4.3c0.1 0.5-0.1 1.4-0.4 1.8C686.8 354.2 684 358.3 684 361.5z"/>
		<path d="M695.5 475c-1.2 0-2.5 0.3-2.5 0.3 -0.5 0.1-1 0.2-1 0.2 0 0-0.4-0.2-0.8-0.5l-3.8-2.4c-0.5-0.3-0.8-0.1-0.7 0.5l0.5 4.3c0.1 0.5-0.1 1.4-0.4 1.8 0 0-2.8 4.1-2.8 7.3 0 6.3 5.1 11.5 11.5 11.5s11.5-5.1 11.5-11.5S701.9 475 695.5 475z"/>
		<path d="M272.8 504.6c-0.5-6.3-6.1-11-12.4-10.5 -6.3 0.5-11 6.1-10.5 12.4 0.5 6.3 6.1 11 12.4 10.5 1.2-0.1 2.4-0.5 2.4-0.5 0.5-0.2 1-0.3 1-0.3s0.4 0.2 0.9 0.5l3.9 2.1c0.5 0.3 0.8 0 0.7-0.5l-0.9-4.3c-0.1-0.5 0-1.4 0.3-1.8C270.6 512.1 273.1 507.7 272.8 504.6z"/>
		<path d="M260.4 348c-6.3 0.5-11 6.1-10.5 12.4 0.5 6.3 6.1 11 12.4 10.5 1.2-0.1 2.4-0.5 2.4-0.5 0.5-0.2 1-0.3 1-0.3s0.4 0.2 0.9 0.5l3.9 2.1c0.5 0.3 0.8 0 0.7-0.5l-0.9-4.3c-0.1-0.5 0-1.4 0.3-1.8 0 0 2.5-4.3 2.2-7.5C272.3 352.2 266.8 347.5 260.4 348z"/>
		<circle cx="464.8" cy="583.2" r="10.8" className="fill"/>
		<path d="M143.5 338.5c-0.5 0-1 0.5-1 1v11c0 0.6-0.4 1-1 1h-4c-0.5 0-1 0.5-1 1v15c0 0.6 0.5 1 1 1h4c0.6 0 1 0.5 1 1v12c0 0.6 0.5 1 1 1h56c0.6 0 1-0.4 1-1v-42c0-0.5-0.4-1-1-1H143.5z"/>
		<circle cx="171.6" cy="360.1" r="14.6"/>
		<circle cx="171.5" cy="353.3" r="2.5"/>
		<circle cx="171.5" cy="367.3" r="2.5"/>
		<circle cx="178.5" cy="360.3" r="2.5"/>
		<path d="M143.5 484.5c-0.5 0-1 0.5-1 1v11c0 0.6-0.4 1-1 1h-4c-0.5 0-1 0.5-1 1v15c0 0.6 0.5 1 1 1h4c0.6 0 1 0.5 1 1v12c0 0.6 0.5 1 1 1h56c0.6 0 1-0.4 1-1v-42c0-0.5-0.4-1-1-1H143.5z"/>
		<circle cx="171.6" cy="506.1" r="14.6"/>
		<circle cx="171.5" cy="499.3" r="2.5"/>
		<circle cx="171.5" cy="513.3" r="2.5"/>
		<circle cx="178.5" cy="506.3" r="2.5"/>
		<path d="M149.9 571c-0.3-0.5-1-0.9-1.5-0.9l-12.6 0c-0.5 0-1.2 0.4-1.5 0.9l-6.3 10.6c-0.3 0.5-0.3 1.2 0 1.7l6.3 10.6c0.3 0.5 1 0.9 1.5 0.9l12.6 0c0.6 0 1.2-0.4 1.5-0.9l6.3-10.6c0.3-0.5 0.3-1.2 0-1.7L149.9 571z"/>
		<circle cx="142.5" cy="582.3" r="7.8"/>
		<path d="M208.9 571c-0.3-0.5-1-0.9-1.5-0.9l-12.6 0c-0.5 0-1.2 0.4-1.5 0.9l-6.3 10.6c-0.3 0.5-0.3 1.2 0 1.7l6.3 10.6c0.3 0.5 1 0.9 1.5 0.9l12.6 0c0.6 0 1.2-0.4 1.5-0.9l6.3-10.6c0.3-0.5 0.3-1.2 0-1.7L208.9 571z"/>
		<circle cx="201.5" cy="582.3" r="7.8"/>
		<path d="M719.9 572c-0.3-0.5-1-0.9-1.5-0.9l-12.6 0c-0.5 0-1.2 0.4-1.5 0.9l-6.3 10.6c-0.3 0.5-0.3 1.2 0 1.7l6.3 10.6c0.3 0.5 1 0.9 1.5 0.9l12.6 0c0.6 0 1.2-0.4 1.5-0.9l6.3-10.6c0.3-0.5 0.3-1.2 0-1.7L719.9 572z"/>
		<circle cx="712.5" cy="583.3" r="7.8"/>
		<path d="M790.9 571c-0.3-0.5-1-0.9-1.5-0.9l-12.6 0c-0.5 0-1.2 0.4-1.5 0.9l-6.3 10.6c-0.3 0.5-0.3 1.2 0 1.7l6.3 10.6c0.3 0.5 1 0.9 1.5 0.9l12.6 0c0.6 0 1.2-0.4 1.5-0.9l6.3-10.6c0.3-0.5 0.3-1.2 0-1.7L790.9 571z"/>
		<circle cx="783.5" cy="582.3" r="7.8"/>
	</svg>,
	<svg key="microphones" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 933 933" >
		<circle className="outline" cx="464.5" cy="464.5" r="464"/>
		<path d="M329.2 657.2C339.5 664.5 370.5 670.5 463.6 670.5s129.2-10.7 138.9-17"/>
		<path d="M328.4 667.7c10.3 7.3 42.1 14.8 135.3 14.8S592.8 672.3 602.5 666"/>
		<path d="M403 766.5c0 1.4 0 61.9 0 67s1.7 7 5.9 8.3 10.9 5.9 54.8 6.1c49.7 0 59.5-5.9 62.6-8S531 836 531 832.5s-0.7-64.5 0-66 8.1-4 11.3-8 2.8-6.6 2.8-10 0-14.2 0-19 -6-9.7-6-11 -0.9-3.6 0-5 15-4 18.5-5 11.1-4.9 16.7-8.7 25.1-16 27.1-18.7 3.8-7 3.8-9.3 0-5.8 0-5.8h-2.5l0-12.5c0 0 1.7-0.9 2.5-2s0.2-131 0.2-131 6.9-1.3 10-2.7 8.9-2.9 10.9-4.7 1.9-3.2 1.9-5.3 0-47.7 0-50.3c-0.6-8.6-14.5-10.5-14.5-10.5s6.6-285.2 7-308.7c0.1-21-18.1-39.5-38.3-39.2 -11.3 0-205.3 0-234.7 0s-46.1 19.9-45 48.1S314.8 449 314.8 449 301 451.6 301 459.5s0.1 48.1 0 51 1.4 4.2 3.5 6 7.4 3.9 10 4.3 9.7 1.7 9.7 1.7l2.3 131c0 0 2.7 2.8 2.7 3.7s-0.1 7.6-0.1 9.3S327 667.6 327 669.2s0 8.8 0 10.3 2.4 3.9 4.2 5 32.5 20.7 34.7 22 7.3 3.7 10.6 4.3S394 712.6 394 713.5s0.1 4.3 0 6c0 1.3-2.8 1.9-4.2 3 -0.5 0.4-0.8 0.8-0.8 1.3 0 2-0.1 31.2 0 32.7C389 763.2 403 765.1 403 766.5z"/>
		<path d="M321 449.9c0 2.5 0.5 4.1 2.3 4.3 35.5 7.3 224.8 4.1 280.9-0.4 1.8-0.8 2.6-1.5 2.7-4s7-290.2 7-309.6c-0.3-17.4-16-33.3-30.7-33.3s-213.7 0.5-230.7 0c-17.7-1.5-44.6 13.7-43.3 38.8C310.3 175.5 321 447.5 321 449.9z"/>
		<path d="M324.3 522.7c0 0 26.5 2.3 53.2 2.3s140 0.5 170 0 57.7-4.5 57.7-4.5"/>
		<path d="M305.1 452.9c-0.7 17.5 92.4 13.8 159.4 13.1 65.9-0.7 156.8 0.4 157.8-16.1"/>
		<path d="M465.1 545.2c-0.8-0.8-2.1-0.8-2.8 0l-52.6 54.6c-0.8 0.8-0.8 2.1 0 2.9l53.4 54.4c0.8 0.8 2 0.8 2.8 0l53.2-56.1c0.8-0.8 0.7-2.1-0.1-2.9L465.1 545.2z"/>
		<path d="M465.1 554.9c-0.8-0.8-2.1-0.7-2.9 0l-45.1 44.8c-0.8 0.8-0.8 2 0 2.8l45.8 45.6c0.8 0.8 2 0.8 2.8 0l45.8-46.9c0.8-0.8 0.7-2-0.1-2.8L465.1 554.9z"/>
		<path d="M471 618.5v-32"/>
		<path d="M457 585.5v33"/>
		<path d="M488 601.8c0-10.2-7.1-18.9-17-21.9v6.1c6.7 2.7 11.4 8.9 11.4 16.2 0 7.3-4.7 13.5-11.4 16.2v5.3C480.9 620.7 488 612 488 601.8z"/>
		<path d="M445.1 602.2c0-7.4 4.9-13.8 11.9-16.3v-6.2c-10.3 2.7-17.9 11.6-17.9 22.1 0 10.5 7.6 19.4 17.9 22.1v-5.4C450 616 445.1 609.7 445.1 602.2z"/>
		<path d="M457 623.5V640h14v-16.5"/>
		<path d="M471 579.5V564h-14v15.5"/>
		<path d="M389.8 722.5c0 0 12.1 7.3 74.6 6.6s76.2-8.3 76.2-8.3"/>
		<path d="M403 766.5c0 0 12.8 5 62.8 4.3S531 766.5 531 766.5"/>
		<line x1="316.5" y1="123.5" x2="328.4" y2="455"/>
		<line x1="322.4" y1="117.5" x2="333.5" y2="455.6"/>
		<line x1="329.2" y1="112.8" x2="338.5" y2="456.2"/>
		<line x1="338.5" y1="108.8" x2="345.5" y2="456.9"/>
		<line x1="352.5" y1="107" x2="357.5" y2="457.5"/>
		<line x1="367" y1="107.5" x2="367" y2="457.5"/>
		<line x1="380" y1="107.5" x2="380" y2="457.5"/>
		<line x1="393" y1="107.5" x2="393" y2="458.5"/>
		<line x1="406" y1="107.5" x2="406" y2="458.5"/>
		<line x1="419" y1="107.5" x2="419" y2="458.5"/>
		<line x1="432" y1="107.5" x2="432" y2="458.5"/>
		<line x1="444" y1="107.5" x2="444" y2="458.5"/>
		<line x1="457" y1="107.5" x2="457" y2="458.5"/>
		<line x1="470" y1="107.5" x2="470" y2="458.5"/>
		<line x1="482" y1="107.5" x2="482" y2="458.5"/>
		<line x1="495" y1="107.5" x2="495" y2="457.5"/>
		<line x1="508" y1="107.5" x2="508" y2="457.5"/>
		<line x1="521" y1="107.5" x2="521" y2="457.5"/>
		<line x1="534" y1="107.5" x2="534" y2="457.5"/>
		<line x1="547" y1="107.5" x2="547" y2="456.5"/>
		<line x1="560" y1="107.5" x2="560" y2="456.5"/>
		<line x1="573" y1="107.5" x2="573" y2="455.5"/>
		<line x1="583.2" y1="107" x2="583" y2="455.5"/>
		<line x1="593.6" y1="109.5" x2="590" y2="454.9"/>
		<line x1="601.7" y1="115" x2="596" y2="454.5"/>
		<line x1="608.8" y1="123.5" x2="601.7" y2="454.3"/>
		<line x1="332.5" y1="111" x2="596.5" y2="111"/>
		<line x1="325.5" y1="115" x2="601.7" y2="115"/>
		<line x1="318.5" y1="121" x2="607.5" y2="121"/>
		<line x1="311.5" y1="131" x2="612.5" y2="131"/>
		<line x1="309.5" y1="144" x2="613.5" y2="144"/>
		<line x1="309.5" y1="157" x2="613.5" y2="157"/>
		<line x1="310.5" y1="170" x2="613.5" y2="170"/>
		<line x1="310.5" y1="183" x2="613.5" y2="183"/>
		<line x1="311.5" y1="196" x2="612.5" y2="196"/>
		<line x1="311.5" y1="209" x2="612.5" y2="209"/>
		<line x1="312.5" y1="222" x2="612.5" y2="222"/>
		<line x1="312.5" y1="235" x2="611.5" y2="235"/>
		<line x1="313.5" y1="248" x2="611.5" y2="248"/>
		<line x1="313.5" y1="261" x2="611.5" y2="261"/>
		<line x1="314.5" y1="274" x2="610.5" y2="274"/>
		<line x1="314.5" y1="287" x2="610.5" y2="287"/>
		<line x1="315.5" y1="300" x2="610.5" y2="300"/>
		<line x1="315.5" y1="313" x2="610.5" y2="313"/>
		<line x1="316.5" y1="326" x2="609.5" y2="326"/>
		<line x1="316.5" y1="339" x2="609.5" y2="339"/>
		<line x1="317.5" y1="352" x2="609.5" y2="352"/>
		<line x1="317.5" y1="365" x2="608.5" y2="365"/>
		<line x1="318.5" y1="378" x2="608.5" y2="378"/>
		<line x1="318.5" y1="391" x2="608.5" y2="391"/>
		<line x1="319.5" y1="404" x2="607.5" y2="404"/>
		<line x1="319.5" y1="417" x2="607.5" y2="417"/>
		<line x1="320.5" y1="430" x2="607.5" y2="430"/>
		<line x1="320.5" y1="443" x2="607.5" y2="443"/>
	</svg>,
	<svg key="instruments" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 933 933">
		<circle className="outline" cx="464.5" cy="464.5" r="464"/>
		<path d="M435.4 567.5h59.5c0 0-8.8-356.1-9.1-372.5s11.5-29.9 11.5-29.9 0.2-83.7 0-88.4 -4.2-7.1-7.5-7.1 -49.7-0.2-55.2 0c-5.5 0.2-10.2 3.1-10.2 7.1 0 4 0 87.3 0 87.3s16.3 12.6 16.1 30.4C440.3 212.1 435.4 567.5 435.4 567.5z"/>
		<circle cx="464.8" cy="632.7" r="37.1"/>
		<path d="M436 522.8c-40.3 0.4-62.5 30.9-68.7 51.6s-0.4 45.1 6.9 58.2c13.8 33.1 13.8 45.1-4 70.6 -89.1 112.7-8.4 181.5 94.4 181.1"/>
		<path d="M493.8 522.9c40.3 1 61.9 31.9 67.8 52.8 5.8 20.8-0.4 45.1-7.9 58.1 -14.4 32.9-14.6 44.9 2.8 70.6 87.2 114.2 10.8 182-91.9 180"/>
		<rect x="406.5" y="755.5" width="119" height="29"/>
		<path d="M506.5 766.5c0 1.1-0.9 2-2 2h-76c-1.1 0-2-0.9-2-2l0 0c0-1.1 0.9-2 2-2h76C505.6 764.5 506.5 765.4 506.5 766.5L506.5 766.5z"/>
		<line x1="439.2" y1="764.5" x2="444.4" y2="149.4"/>
		<polyline points="444.4 96 455.9 208.6 457.5 764.5 "/>
		<polyline points="475.8 764.5 470.9 208.6 478.8 96 "/>
		<polyline points="481 149.4 483.2 208.3 493.5 764.5 "/>
		<line x1="436" y1="517.5" x2="494" y2="517.5"/>
		<line x1="494" y1="502.5" x2="437" y2="502.5"/>
		<line x1="437" y1="487.5" x2="492" y2="487.5"/>
		<line x1="492" y1="471.5" x2="437" y2="471.5"/>
		<line x1="437" y1="453.5" x2="492" y2="453.5"/>
		<line x1="491" y1="433.5" x2="437" y2="433.5"/>
		<line x1="491" y1="413.5" x2="438" y2="413.5"/>
		<line x1="438" y1="392.5" x2="490" y2="392.5"/>
		<line x1="490" y1="370.5" x2="438" y2="370.5"/>
		<line x1="489" y1="347.5" x2="438" y2="347.5"/>
		<line x1="489" y1="322.5" x2="439" y2="322.5"/>
		<line x1="488" y1="297.5" x2="439" y2="297.5"/>
		<line x1="488" y1="270.5" x2="439" y2="270.5"/>
		<line x1="487" y1="240.5" x2="440" y2="240.5"/>
		<line x1="486" y1="210.5" x2="440" y2="210.5"/>
		<circle cx="441.5" cy="95.9" r="6.6"/>
		<circle cx="441.4" cy="96" r="3"/>
		<circle cx="481.9" cy="95.9" r="6.6"/>
		<circle cx="481.8" cy="96" r="3"/>
		<circle cx="484.1" cy="149.3" r="6.6"/>
		<circle cx="484" cy="149.4" r="3"/>
		<circle cx="441.5" cy="149.3" r="6.6"/>
		<circle cx="441.4" cy="149.4" r="3"/>
	</svg>
]

const HomeGalleryIcon = ({ cat }) => (
	<Wrapper>
		<Link to={`/gallery/${cat}`}>
			<div className="inner">
        { icons.map(icon => icon.key === cat && icon) }
        <span>{cat}</span>
      </div>
		</Link>
	</Wrapper>
)

export default HomeGalleryIcon


// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/home/HomeGalleryIcon.js